namespace Serenity {
    export interface OperationServiceRequest extends Serenity.ServiceRequest {
        OperationGuid?: string;
    }
}
